import * as React from 'react';
import { FormGroup, Label } from './styles/common';
import getFieldId from './getFieldId';

export function FormInputNumber({
  label,
  registration,
  error,
  valid,
  min,
  max,
  step = 1,
  placeholder,
}) {
  const fieldId = getFieldId(undefined, registration);
  const errorId = error ? `${fieldId}-error` : undefined;

  return (
    <FormGroup>
      {label !== undefined && <Label htmlFor={fieldId}>{label}</Label>}
      <input
        id={fieldId}
        min={min}
        max={max}
        step={step}
        placeholder={placeholder}
        className={`form-control ${error ? 'is-invalid' : ''} ${valid ? 'is-valid' : ''}`}
        type="number"
        {...registration}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={errorId}
      />
      <div className="invalid-feedback" id={errorId}>{error}</div>
    </FormGroup>
  );
}
